import React from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Typography,
  Divider
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { designTokens } from '../../theme/designTokens';
import PredefinedPrompts from './PredefinedPrompts';
import RecordAnalysis from './RecordAnalysis';
import {
  selectSelectedRecords
} from '../../features/analysis/analysisSlice';

const AnalysisStep = () => {
  const theme = useTheme();
  const selectedRecords = useSelector(selectSelectedRecords);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Divider />
      {/* Main Content Area - Two Panel Layout */}
      <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        {/* Left Panel - Prompts */}
        <Box sx={{
          width: '25%',
          borderRight: `1px solid ${theme.palette.grey[200]}`,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          <PredefinedPrompts />
        </Box>

        {/* Right Panel - Analysis */}
        <Box sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          <RecordAnalysis />
        </Box>
      </Box>
    </Box>
  );
};

export default AnalysisStep;
